import { BaseFilterOption } from './types';
import { shortConfig as cancerKnowledgeBaseConfig } from './jaxCKB';
import { config as clinVarReviewConfig } from './clinVarReview';
import { config as clinVarSignificanceConfig } from './clinVarSignificance';
import { config as codingEffectConfig } from './codingEffect';
import { config as cosmicIDsConfig } from './cosmicIds';
import { config as cosmicMinimumCountConfig } from './cosmicMinimumCount';
import { config as dbSNPrsIDsConfig } from './dbSNPrsIDs';
import { config as geneClassConfig } from './geneClass';
import { config as geneConfig } from './gene';
import { config as geneSetsConfig } from './geneSets';
import { config as maxAcrossPopulationsConfig } from './maxAcrossPopulations';
import { config as popAlleleFrequencyConfig } from './populationAlleleFrequency';
import { config as positionConfig } from './position';
import { config as proteinChangesConfig } from './proteinChanges';
import { config as zygosityConfig } from './zygosity';
import { config as variantAlleleFrequencyConfig } from './variantAlleleFrequency';
import { config as combinedInSilicoPredictionConfig } from './combinedInSilicoPrediction';
import { config as individualInSilicoPredictorsConfig } from './individualInSilicoPredictors';
import { config as variantQualityConfig } from './variantQuality';
import { config as proteinEffectConfig } from './proteinEffect';
import { config as selectedConfig } from './selected';
import {
  LabReportedSignificance,
  buildConfig as buildLabReportedSignificanceConfig,
} from './labReportedSignificance';

const labReportedSignificanceConfig = buildLabReportedSignificanceConfig({
  searchKey: 'vendSig',
  valuesToInclude: [
    LabReportedSignificance.Pathogenic,
    LabReportedSignificance.LikelyPathogenic,
    LabReportedSignificance.Benign,
    LabReportedSignificance.LikelyBenign,
    LabReportedSignificance.UncertainSignificance,
  ],
});

export const shortOptions: Array<Partial<BaseFilterOption>> = [
  { ...selectedConfig },
  { ...cancerKnowledgeBaseConfig },
  { ...geneSetsConfig },
  { ...geneConfig },
  { ...codingEffectConfig },
  { ...proteinChangesConfig },
  { ...proteinEffectConfig },
  { ...positionConfig },
  { ...cosmicMinimumCountConfig },
  { ...cosmicIDsConfig },
  { ...dbSNPrsIDsConfig },
  { ...labReportedSignificanceConfig },
  { ...clinVarSignificanceConfig },
  { ...clinVarReviewConfig },
  { ...popAlleleFrequencyConfig },
  { ...maxAcrossPopulationsConfig },
  { ...geneClassConfig },
  { ...zygosityConfig },
  { ...variantQualityConfig },
  { ...variantAlleleFrequencyConfig },
  { ...combinedInSilicoPredictionConfig },
  { ...individualInSilicoPredictorsConfig },
];
